import React, { useState, useEffect } from "react";
import Data from "../App";
import { map, distinctUntilChanged } from "rxjs/operators";
import CompJsonEdit from "./CompJsonEdit";
import SignalView from "./SignalView";

function checkModel(model) {
  let valid = true;
  if (!model.get("id")) valid = false;
  if (!model.get("name")) valid = false;
  return valid;
}

const SignalGroup = ({ signalGroup, editing, onChange }) => {
  let variants = "";
  if (signalGroup.get("variants"))
    variants = signalGroup.get("variants").map((variant, index) => (
      <div key={variant.get("id")} style={{ marginLeft: 6 * index }}>
        <SignalView signal={variant} />
      </div>
    ));
  let editBox = "";
  if (editing)
    editBox = (
      <CompJsonEdit
        json={JSON.stringify(signalGroup.get("variants"))}
        onSet={newObj => onChange(signalGroup.set("variants", newObj))}
        filterFct={item => checkModel(item)}
      />
    );
  return (
    <div className="SignalGroupView">
      {variants}
      {editBox}
    </div>
  );
};
export default SignalGroup;



// WEBPACK FOOTER //
// ./src/components/SignalGroup.js